<template>
  <v-container>
    <v-card
      color="oug"
      class="pa-1 mx-auto text-center justify-center"
      max-width="600"
      elevation="24"
    >
      <v-card-title class="text-h6 white--text">My Bookings</v-card-title>
      <v-card-subtitle class="white--text" align="start">
        Here is a list of your current bookings, including events that have
        already occurred for your reference.
      </v-card-subtitle>
                <div>
      <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="oug"
        dark
      >
        <v-card-text>
          Loading Bookings. Please Stand By
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
      <v-list dense>
        <v-list-item v-for="(item, i) in userBookings" :key="i">
          <v-list-item-content>
            <v-list-item-title v-text="item.date"></v-list-item-title>
            <v-list-item-title v-text="item.name"></v-list-item-title>
            <v-divider class="mt-2"></v-divider>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <div class="mt-5" v-if="this.userBookings.length == 0">
        <p align="center">
          You have no current bookings. To book in for an upcoming
          course/clinic, visit the Calendar/Events section of the App. If you
          believe you made a booking but nothing is appearing, contact Luke
          McGuire in the People section of the App
        </p>
    </div>
  </v-container>
</template>

<script>
import { authComputed, getUser } from "../veux/helpers";
import axios from "axios";

export default {
  data() {
    return {
      loadingDialog: false,
      userBookings: [],
    };
  },
  created() {
    this.getBookings();
    // console.log("userbookings", this.userBookings);
  },
  methods: {
    getBookings() {
      this.userBookings = [];
      const payload = { Event_id: 0, Contact_id: this.currentUser.Contact_id };
      this.loadingDialog = true;
      const baseURL = "https://server.ownurgoal.net.au/gen/GetBookings";
      axios.post(baseURL, payload).then((response) => {
        this.allBookings = response.data.result;
        // console.log("bookings response", this.allBookings);
        this.allBookings.forEach((element) => {
          this.userBookings.push({
            date: element.Date,
            name: element.Eventname,
          });
        });
        this.userBookings.reverse();
        this.loadingDialog = false;
      });
    },
  },
  computed: {
    ...authComputed,
    ...getUser,
  },
};
</script>

<style>
</style>